import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Company Exist
export const companyExist = createAsyncThunk(
  "companyExist",
  async ({ id = null, company_name = null }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `company-exist?name=${company_name}&id=${id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Email Exist
export const emailExist = createAsyncThunk(
  "emailExist",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`auth/email-exist`, data);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Company UNE Exist
export const companyUENExist = createAsyncThunk(
  "companyUENExist",
  async ({ id, number }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `company-exist?uen=${number}&id=${id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Business Activities
export const businessActivities = createAsyncThunk(
  "businessActivities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`business-activities`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Company Data
export const companyData = createAsyncThunk(
  "companyData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`company-data`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Company
export const CreateCompany = createAsyncThunk(
  "CreateCompany",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`companies`, data);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Address
export const Address = createAsyncThunk(
  "Address",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`registered_address`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);
// Create Address
export const createAddress = createAsyncThunk(
  "createAddress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`address`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);
// Existing Users
export const existingUsers = createAsyncThunk(
  "existingUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`existing-users`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Director / Shareholder
export const addDirectorShareholder = createAsyncThunk(
  "addDirectorShareholder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`users`, data);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// employment pass
export const employmentPass = createAsyncThunk(
  "employmentPass",
  async (_, { rejectWithValue }) => {
    try {
      // const response = await AxiosApi.get(`master-settings?slug=${slug}`);
      const response = await AxiosApi.get(`employment-details`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);
// Employment Support
export const employmentSupport = createAsyncThunk(
  "employmentSupport",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`companies/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);
// company payment summary
export const paymentSummary = createAsyncThunk(
  "paymentSummary",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`company-payment-summary/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);
// make payment
export const makePayment = createAsyncThunk(
  "makePayment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`make-payment`, data);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || error.response.data.error);
      return rejectWithValue(error.response.data || error.response.data.error);
    }
  }
);

// Delete Director / Shareholder
export const DeleteDirectorShareholder = createAsyncThunk(
  "DeleteDirectorShareholder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`users/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Nominee Directors Details
export const getNomineeDirectorsDetails = createAsyncThunk(
  "getNomineeDirectorsDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `master-settings?slug=nominee_director`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get Company Subscription Summary
export const getCompanySubscriptionSummary = createAsyncThunk(
  "getCompanySubscriptionSummary",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`company-subscription-summary/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Corporate Secretary
export const getCorporateSecretary = createAsyncThunk(
  "corporate_secretary",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `master-settings?slug=corporate_secretary`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Currencies
export const getCurrencies = createAsyncThunk(
  "getCurrencies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`get-currencies`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Company
export const getCompany = createAsyncThunk(
  "getCompany",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `companies?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get all Company
export const getAllCompany = createAsyncThunk(
  "getAllCompany",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`companies`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Business Types
export const getBusinessTypes = createAsyncThunk(
  "getBusinessTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`business-enitity`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Entity Types
export const getEntityTypes = createAsyncThunk(
  "getEntityTypes",
  async (businessTypeId, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `company-data?business_entity=${businessTypeId}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Suffixes
export const getSuffixes = createAsyncThunk(
  "getSuffixes",
  async ({ entityTypeId = "", businessTypeId = "" }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `suffixes?company_type=${entityTypeId}&business_entity=${businessTypeId}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Company Exist
      .addCase(companyExist.pending, (state) => {
        state.companyExistStatus.loading = true;
      })
      .addCase(companyExist.fulfilled, (state, action) => {
        state.companyExistStatus.loading = false;
        state.companyExistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(companyExist.rejected, (state) => {
        state.companyExistStatus.loading = false;
        state.error = true;
      })
      // email Exist
      .addCase(emailExist.pending, (state) => {
        state.emailExistStatus.loading = true;
      })
      .addCase(emailExist.fulfilled, (state, action) => {
        state.emailExistStatus.loading = false;
        state.emailExistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(emailExist.rejected, (state) => {
        state.emailExistStatus.loading = false;
        state.error = true;
      })
      // Company UEN Exist
      .addCase(companyUENExist.pending, (state) => {
        state.companyUENExistStatus.loading = true;
      })
      .addCase(companyUENExist.fulfilled, (state, action) => {
        state.companyUENExistStatus.loading = false;
        state.companyUENExistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(companyUENExist.rejected, (state) => {
        state.companyUENExistStatus.loading = false;
        state.error = true;
      })
      // Business Activities
      .addCase(businessActivities.pending, (state) => {
        state.businessActivitiesStatus.loading = true;
      })
      .addCase(businessActivities.fulfilled, (state, action) => {
        state.businessActivitiesStatus.loading = false;
        state.businessActivitiesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(businessActivities.rejected, (state) => {
        state.businessActivitiesStatus.loading = false;
        state.error = true;
      })
      // Company Data
      .addCase(companyData.pending, (state) => {
        state.loading = true;
      })
      .addCase(companyData.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDataStatus.data = action.payload;
        state.error = false;
      })
      .addCase(companyData.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Address
      .addCase(Address.pending, (state) => {
        state.loading = true;
      })
      .addCase(Address.fulfilled, (state, action) => {
        state.loading = false;
        state.AddressStatus.data = action.payload;
        state.error = false;
      })
      .addCase(Address.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Company
      .addCase(CreateCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.CreateCompanyStatus.data = action.payload;
        state.error = false;
      })
      .addCase(CreateCompany.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Add Director Shareholder
      .addCase(addDirectorShareholder.pending, (state) => {
        state.addDirectorShareholderStatus.loading = true;
      })
      .addCase(addDirectorShareholder.fulfilled, (state, action) => {
        state.addDirectorShareholderStatus.loading = false;
        state.addDirectorShareholderStatus.data = action.payload;
        state.error = false;
      })
      .addCase(addDirectorShareholder.rejected, (state) => {
        state.addDirectorShareholderStatus.loading = false;
        state.error = true;
      })
      // Existing Users
      .addCase(existingUsers.pending, (state) => {
        state.existingUsersStatus.loading = true;
      })
      .addCase(existingUsers.fulfilled, (state, action) => {
        state.existingUsersStatus.loading = false;
        state.existingUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(existingUsers.rejected, (state) => {
        state.existingUsersStatus.loading = false;
        state.error = true;
      })
      // employment Pass
      .addCase(employmentPass.pending, (state) => {
        state.loading = true;
      })
      .addCase(employmentPass.fulfilled, (state, action) => {
        state.loading = false;
        state.employmentPassStatus.data = action.payload;
        state.error = false;
      })
      .addCase(employmentPass.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // employment Support
      .addCase(employmentSupport.pending, (state) => {
        state.loading = true;
      })
      .addCase(employmentSupport.fulfilled, (state, action) => {
        state.loading = false;
        state.employmentSupportStatus.data = action.payload;
        state.error = false;
      })
      .addCase(employmentSupport.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // paymentASummary
      .addCase(paymentSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(paymentSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentSummaryStatus.data = action.payload;
        state.error = false;
      })
      .addCase(paymentSummary.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Director Shareholder
      .addCase(DeleteDirectorShareholder.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteDirectorShareholder.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteDirectorShareholderStatus.data = action.payload;
        state.error = false;
      })
      .addCase(DeleteDirectorShareholder.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Nominee Directors Details
      .addCase(getNomineeDirectorsDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNomineeDirectorsDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.getNomineeDirectorsDetailsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getNomineeDirectorsDetails.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Company Subscription Summary
      .addCase(getCompanySubscriptionSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanySubscriptionSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanySubscriptionSummaryStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompanySubscriptionSummary.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Make Payment
      .addCase(makePayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(makePayment.fulfilled, (state, action) => {
        state.loading = false;
        state.makePaymentStatus.data = action.payload;
        state.error = false;
      })
      .addCase(makePayment.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Corporate Secretary Details
      .addCase(getCorporateSecretary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCorporateSecretary.fulfilled, (state, action) => {
        state.loading = false;
        state.getCorporateSecretaryStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCorporateSecretary.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Company
      .addCase(getCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanyStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompany.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get all Company
      .addCase(getAllCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.getAllCompanyStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAllCompany.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Business Types
      .addCase(getBusinessTypes.pending, (state) => {
        state.businessTypesStatus.loading = true;
      })
      .addCase(getBusinessTypes.fulfilled, (state, action) => {
        state.businessTypesStatus.loading = false;
        state.businessTypesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getBusinessTypes.rejected, (state) => {
        state.businessTypesStatus.loading = false;
        state.error = true;
      })
      // Get Entity Types
      .addCase(getEntityTypes.pending, (state) => {
        state.entityTypesStatus.loading = true;
      })
      .addCase(getEntityTypes.fulfilled, (state, action) => {
        state.entityTypesStatus.loading = false;
        state.entityTypesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getEntityTypes.rejected, (state) => {
        state.entityTypesStatus.loading = false;
        state.error = true;
      })
      // Get Suffixes
      .addCase(getSuffixes.pending, (state) => {
        state.suffixesStatus.loading = true;
      })
      .addCase(getSuffixes.fulfilled, (state, action) => {
        state.suffixesStatus.loading = false;
        state.suffixesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSuffixes.rejected, (state) => {
        state.suffixesStatus.loading = false;
        state.error = true;
      })
      // Get Currencies
      .addCase(getCurrencies.pending, (state) => {
        state.getCurrenciesStatus.loading = true;
      })
      .addCase(getCurrencies.fulfilled, (state, action) => {
        state.getCurrenciesStatus.loading = false;
        state.getCurrenciesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCurrencies.rejected, (state) => {
        state.getCurrenciesStatus.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = companiesSlice;
export default reducer;
